import React, { useState,useEffect } from 'react'
import { IntlProvider, FormattedMessage, injectIntl } from 'react-intl';
import { Helmet } from "react-helmet-async";
import {
    JSONLD,
    Generic,
    GenericCollection
} from 'react-structured-data';
import LogoImgage from './../../assets/images/meta-image.jpg'
import { useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import languages from 'locales';

const Data = (props) => {
    const { intl } = props
    const [newsDetailsFiltered,setNewsDetailsFiltered]=useState(null)
    const newsSelector = useSelector((state) => state.leadbest.news);
    const newsDetails = newsSelector.newsDetails
    const history = useHistory()
    const global = useSelector((state) => state.global);

    const languagesIndex = languages[global.locale].id;

    const correspondingLanguage = (translations) => {
        const language = languagesIndex == 0 ? 'zh-TW' : 'en-US'
        return translations.find((item) => item.languages_id.code == language)
    }
    
    useEffect(()=>{
       if(newsDetails.loading)return;
       if(!newsDetails.loaded)return;
       setNewsDetailsFiltered(correspondingLanguage(newsDetails.data.translations))
    },[newsDetails])
    return (
        <>
            {/* structured Data */}
            {!newsDetails.loading && newsDetails.loaded && newsDetailsFiltered&&
            <JSONLD>
                
                <Generic type="newsArticle" jsonldtype="NewsArticle"
                    schema={{headline:newsDetailsFiltered.title,
                            datePublished:newsDetails.data.date_created,
                            dateModified:newsDetails.data.date_updated,
                            description:newsDetailsFiltered.contents.find((item) => item.type == "TEXT")?.content,
                            isAccessibleForFree:true,
                            mainEntityOfPage:`https://www.leadbestgroup.com${history.location.pathname}`,
                            url:`https://www.leadbestgroup.com${history.location.pathname}`,
                            thumbnailUrl:`${window.Config.LEADBEST_OFFICIAL_WEBSITE_API_HOST}/assets/${newsDetails.data.cover?.id}?fit=cover&width=466&height=261`,
                            keywords:  newsDetails.data.tags?.map((tag) =>{return tag.news_tags_id.name})
                            }}>
                    <Generic type="author" jsonldtype="Person"
                        schema={{name:newsDetailsFiltered.publisher}}/>
                    <Generic type="image" jsonldtype="ImageObject"
                        schema={{url:`${window.Config.LEADBEST_OFFICIAL_WEBSITE_API_HOST}/assets/${newsDetails.data.cover?.id}?fit=cover&width=466&height=261`,
                                width:466,
                                height:221}}/>     
                    <Generic type="publisher" jsonldtype="Organization"
                        schema={{name:'LeadBest',}}>
                            <Generic type="logo" jsonldtype="ImageObject"
                                    schema={{url:`https://www.leadbestgroup.com${LogoImgage}`,}}/>     
                    </Generic>         
                </Generic>
            </JSONLD>
              }   
        </>
    )
}
export default injectIntl(Data)